import { Icon } from '@common/components/Icon';
import { Palette } from '@common/theming/Palette';
import React from 'react';
import { AssetBlockProps } from '../../pages/Asset';
import { TextBlock } from '../TextBlock';

export const Features: React.FC<AssetBlockProps> = ({ asset }) => {
  return (
    <div>
      <TextBlock color={Palette.BLACK} weight={'bold'} size={24}>
        {asset.assetFeatures?.heading}
      </TextBlock>

      <div>
        {asset.assetFeatures?.items.map((item, i) => (
          <div key={`assetFeature-${i}`} style={{ alignItems: 'flex-start', display: 'flex', marginTop: 24 }}>
            <div
              style={{
                alignItems: 'center',
                backgroundColor: Palette.BLUE_GRAY,
                borderRadius: 5,
                display: 'flex',
                height: 30,
                justifyContent: 'center',
                minHeight: 30,
                minWidth: 30,
                width: 30,
              }}>
              <Icon icon={item.icon} color="white" />
            </div>
            <TextBlock color={Palette.BLACK} size={16} style={{ marginLeft: 15 }}>
              {item.text}
            </TextBlock>
          </div>
        ))}
      </div>
    </div>
  );
};
